import { DateTimeIcon } from "./DateTimeIcon";
import { Popup } from "antd-mobile";
import { format } from "date-fns";
import { ConfirmIcon } from "./ConfirmIcon";
import { CloseIcon } from "./CloseIcon";
import { IRange } from "../History";
import { addDays } from "date-fns";
import { clsx } from "clsx";
import { FormattedMessage } from "react-intl";

import { DateRange, RangeKeyDict, Range } from "react-date-range";
import "styles/react-date-range/styles.css"; // main css file
import "styles/react-date-range/theme.default.css"; // theme css file
import { useEffect, useState } from "react";

export type StateType = { startDate: Date; endDate: Date; key: string };

type DatePickerProps = {
  range?: IRange;
  onChangeRange?: (newRange?: IRange) => void;
  onClear: () => void;
};

export const DatePicker = ({
  range,
  onChangeRange,
  onClear,
}: DatePickerProps) => {
  const [visible, setVisible] = useState<boolean>(false);
  const start = range?.startDate ? new Date(range.startDate) : null;
  const end = range?.endDate ? new Date(range.endDate) : null;
  const startDate = start ? format(start, "MM/dd/yyyy") : "";
  const endDate = end ? format(end, "MM/dd/yyyy") : "";

  const [state, setState] = useState<Range>({});

  const onConfirm = () => {
    onChangeRange?.({
      startDate: state?.startDate?.getTime(),
      endDate: state?.endDate?.getTime(),
    });
    setVisible(false);
  };

  const onChangeDate = (item: RangeKeyDict) => {
    const selection = item.selection;
    setState(selection);
  };

  const onClickButton = (day: number) => {
    onSetDate(day);
    onChangeRange?.({
      startDate: new Date(addDays(new Date(), -day)).getTime(),
      endDate: new Date().getTime(),
    });
    setVisible(false);
  };

  const onSetDate = (day: number) => {
    setState((prevState) => {
      return {
        ...prevState,
        startDate: addDays(new Date(), -day),
        endDate: new Date(),
      };
    });
  };

  const initState = () => {
    if (!startDate || !endDate || !range) {
      setState({
        startDate: new Date(),
        endDate: new Date(),
        color: "#00C7AF",
        key: "selection",
      });
    } else {
      setState({
        startDate: startDate ? new Date(startDate) : new Date(),
        endDate: endDate ? new Date(endDate) : new Date(),
        color: "#00C7AF",
        key: "selection",
      });
    }
  };

  useEffect(() => {
    initState();
  }, [range]);

  return (
    <div className="flex flex-row items-center gap-1">
      <span
        className="flex flex-row items-center gap-1 text-xs cursor-pointer"
        onClick={() => setVisible((prev) => !prev)}
      >
        <span className="text-primary">
          <DateTimeIcon />
        </span>
        {startDate && endDate && (
          <>
            <span>{startDate}</span>
            <span>-</span>
            <span>{endDate}</span>
          </>
        )}
      </span>
      {startDate && endDate && (
        <span className="ml-1 text-black333" onClick={onClear}>
          <CloseIcon width={12} height={12} />
        </span>
      )}

      <Popup
        bodyClassName="bg-white dark:bg-black333"
        visible={visible}
        onMaskClick={() => {
          setVisible(false);
        }}
        bodyStyle={{
          borderTopLeftRadius: "16px",
          borderTopRightRadius: "16px",
          minHeight: "480px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          // backgroundColor: "#333",
        }}
      >
        <div className="w-full flex flex-row justify-between py-4 px-4">
          <div
            className="w-6 text-[#283030] dark:text-white80"
            onClick={() => setVisible(false)}
          >
            <CloseIcon />
          </div>
          <span className="text-base font-bold">
            <FormattedMessage id="meter.history.selectDate" />
          </span>
          <div
            className={clsx("w-6", {
              "text-primary": state.startDate && state.endDate,
              "text-[#283030]": !state || state.endDate || !state.startDate,
            })}
            onClick={onConfirm}
          >
            <ConfirmIcon />
          </div>
        </div>

        <DateRange
          fixedHeight
          className="text-[13px]"
          classNames={{
            dateRangeWrapper: "dark:bg-black333 text-white",
            dayDisabled: "dark:bg-black333 dark:text-white-10",
            nextPrevButton: "dark:bg-white-10",
            monthAndYearWrapper: "dark:text-white",
            weekDay: "dark:text-white",
            dayNumber: "dark:text-white",
          }}
          maxDate={new Date()}
          showMonthAndYearPickers={false}
          showDateDisplay={false}
          editableDateInputs={false}
          onChange={onChangeDate}
          moveRangeOnFirstSelection={false}
          ranges={[state]}
          rangeColors={["#00C7AF", "#00C7AF"]}
        />
        <div className="flex items-center flex-row gap-2 text-sm flex-wrap">
          <div
            className="px-3 h-9 leading-9 rounded-[54px] bg-primary text-white"
            onClick={() => onClickButton(7)}
          >
            <FormattedMessage id="meter.history.last7days" />
          </div>
          <div
            className="px-3 h-9 leading-9 rounded-[54px] bg-primary text-white"
            onClick={() => onClickButton(30)}
          >
            <FormattedMessage id="meter.history.last30days" />
          </div>
          <div
            className="px-3 9 leading-9 rounded-[54px] bg-primary text-white"
            onClick={() => onClickButton(90)}
          >
            <FormattedMessage id="meter.history.last90days" />
          </div>
        </div>
      </Popup>
    </div>
  );
};
